{
  "primer": {
    "eyebrow": "Nyakati za swala na Kibla",
    "headline": "Rhemn inahitaji eneo lako kwa nyakati za swala na Kibla.",
    "body": "Tunalitumia kwa nyakati zako za swala, mwelekeo wa Kibla na hali ya hewa ya eneo lako — si kingine.",
    "cta": "Endelea",
    "skip": "Si sasa",
    "skip_body": "Nyakati za swala na Kibla zitabaki zimezimwa."
  }
}
